
import { Vue, Component, Prop } from 'vue-property-decorator';
import { getAspectRatioFromUrl } from '@/common/ts/common';
import XcqManuscriptFooter from './XcqManuscriptFooter.vue';
import TopTag from './TopTag.vue';
import XcqImage from './XcqImage.vue';

@Component({
  components: {
    XcqManuscriptFooter,
    TopTag,
    XcqImage,
  },
})
export default class XcqManuscriptSingleImg extends Vue {
  @Prop({
    default: () => ({
      blockHeaderPic: '',
      blockName: '',
      blockBottomText: '',
      extText1: '',
      data: {
        title: '',
        imageUrl: [],
        newsType: '',
        videoTime: '',
        imageNum: 0,
      },
      list: [],
    }),
  })
  blockInfo!: any;

  @Prop({ default: 349 }) width!: number;

  @Prop({ default: null }) blockDataInfo!: any;

  @Prop({ default: false }) showTop!: boolean;

  @Prop({ default: 0 }) topValue!: number;

  // 计算属性 - 确保始终返回对象
  get dataInfo(): any {
    const info = this.blockDataInfo || (this.blockInfo && this.blockInfo.data);
    return (
      info || {
        title: '',
        imageUrl: [],
        newsType: '',
        videoTime: '',
        imageNum: 0,
      }
    );
  }

  get imgWidth(): number {
    return parseInt(String(this.width * 0.324));
  }

  // 安全获取图片 URL
  getImageUrl(info: any): string {
    if (info && info.imageUrl && info.imageUrl[0]) {
      return info.imageUrl[0];
    }
    return '';
  }

  // 计算图片高度
  getTopImgHeight(url: any): number {
    const ratio = getAspectRatioFromUrl(url) || 1.43;
    return Math.round(this.imgWidth / ratio);
  }

  // 点击事件处理
  handleClick(info: any): void {
    this.$emit('clickItem', info && info.jump, info);
  }
}
